// Arama sesleri için uygulama genelinde TEK bir <audio> seti.
// Safari/iOS bir <audio> öğesinin sesli çalmasına ancak o öğe daha önce bir kullanıcı dokunuşu içinde
// çalındıysa izin veriyor; başka bir AudioContext'in kilidini açmak yetmiyor. Önceden her arama bileşeni
// kendi new Audio()'sunu oluşturuyordu, bu öğelerin kilidi hiç açılmadığı için Safari'de ilk aramada
// zil çalmıyor (NotAllowedError) ve gelen arama fark edilmiyordu.
const soundEndCallFile = require('@/assets/sounds/agora-end-call.wav')
const soundIncomingCallFile = require('@/assets/sounds/agora-incoming-call.wav')
const soundOutgoingCallFile = require('@/assets/sounds/agora-outgoing-call.wav')

let sounds = null

export function getCallSounds() {
  if (!sounds) {
    sounds = {
      soundEndCall: new Audio(soundEndCallFile),
      soundIncomingCall: new Audio(soundIncomingCallFile),
      soundOutgoingCall: new Audio(soundOutgoingCallFile),
    }
  }
  return sounds
}

// Kullanıcı dokunuşu sırasında çağrılmalı: her sesi SESSİZ (muted) çalıp hemen durdurur, böylece Safari
// bu öğelerin daha sonra (arama geldiğinde) çalmasına izin verir.
// Öğeler kilit açıldıktan sonra da muted bırakılır: Safari çal-hemen-durdur sırasında pause()'u bazen yok
// sayıyor; önceden ses burada geri açıldığı için giriş sayfasında ilk dokunuşta zil duyuluyordu.
// Ses yalnızca gerçekten çalınacağı an playCallSound ile açılır.
// Hepsi başarılı olursa true döner.
export function unlockCallSounds() {
  const audios = Object.values(getCallSounds())
  return Promise.all(audios.map(audio => {
    // eslint-disable-next-line no-param-reassign
    audio.muted = true
    const playing = audio.play()
    return Promise.resolve(playing)
      .then(() => {
        audio.pause()
        // eslint-disable-next-line no-param-reassign
        audio.currentTime = 0
        return true
      })
      .catch(() => false)
  })).then(results => results.every(Boolean))
}

// Arama sesini gerçekten (sesli) çalar: kilit açmadan kalan muted durumunu kaldırır
export function playCallSound(audio) {
  // eslint-disable-next-line no-param-reassign
  audio.muted = false
  return audio.play()
}

// Zil çalma izni reddedildiyse (NotAllowedError) kullanıcının bir sonraki dokunuşunda tekrar dener.
// shouldPlay: o an hâlâ çalınmalı mı (ör. arama hâlâ "calling" durumunda mı)
export function retryOnNextInteraction(audio, shouldPlay) {
  const events = ['pointerdown', 'touchstart', 'keydown']
  const retry = () => {
    events.forEach(eventName => document.removeEventListener(eventName, retry, true))
    if (!shouldPlay()) return
    playCallSound(audio).catch(() => {})
  }
  events.forEach(eventName => document.addEventListener(eventName, retry, true))
}
